import { SVGProps } from 'react'
import * as React from 'react'

const ArrowUpIcon: React.FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width="22px"
      height="22px"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16.2349 9.05546L12.2932 5.12296C11.9497 4.7815 11.4851 4.58984 11.0007 4.58984C10.5164 4.58984 10.0517 4.7815 9.70823 5.12296L5.76656 9.05546C5.59583 9.22721 5.5 9.45954 5.5 9.70171C5.5 9.94388 5.59583 10.1762 5.76656 10.348C5.85178 10.4339 5.95316 10.5021 6.06486 10.5486C6.17657 10.5952 6.29638 10.6191 6.41739 10.6191C6.5384 10.6191 6.65822 10.5952 6.76992 10.5486C6.88163 10.5021 6.98301 10.4339 7.06823 10.348L10.0841 7.33213V17.4155C10.0841 17.6586 10.1806 17.8917 10.3525 18.0636C10.5245 18.2356 10.7576 18.3321 11.0007 18.3321C11.2438 18.3321 11.477 18.2356 11.6489 18.0636C11.8208 17.8917 11.9174 17.6586 11.9174 17.4155V7.33213L14.9332 10.348C15.1046 10.5206 15.3376 10.618 15.5808 10.6189C15.8241 10.6197 16.0577 10.5239 16.2303 10.3525C16.4029 10.1812 16.5004 9.9482 16.5012 9.70495C16.5021 9.4617 16.4063 9.22808 16.2349 9.05546Z"
        fill={props.color ? props.color : 'white'}
      />
    </svg>
  )
}

export default ArrowUpIcon
